import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
    constructor(private _apiService: ApiService) {}

    getNotifications(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.NOTIFICATIONS);
    }

    getNotificationsCount(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.NOTIFICATIONS_COUNT);
    }

    readNotification(notificationId: number): Observable<any> {
        return this._apiService.post(API_ENDPOINTS.READ_NOTIFICATION, {
            notificationId,
        });
    }
}
